function NoDataFallback({ title }: { title: string }) {
  return (
    <div className="flex size-full min-h-60 flex-col items-center justify-center rounded border border-gray-200 bg-white shadow-sm">
      <h2 className="font-semibold text-gray-400">No {title} Available</h2>
    </div>
  );
}

export default NoDataFallback;
